export const translations = {
  en: {
    // Navigation
    nav: {
      home: "Home",
      rooms: "Rooms & Suites",
      experiences: "Experiences",
      dining: "Dining",
      spa: "Spa",
      gallery: "Gallery",
      contact: "Contact",
      bookNow: "Book Now"
    },
    // Hero
    hero: {
      title: "Le Château d'Azur",
      subtitle: "A Mediterranean Sanctuary",
      tagline: "Where French elegance meets the azure coastline",
      discover: "Discover"
    },
    // Booking Widget
    booking: {
      checkIn: "Check-in",
      checkOut: "Check-out",
      guests: "Guests",
      guest: "Guest",
      adults: "Adults",
      children: "Children",
      searchAvailability: "Check Availability",
      selectDates: "Select dates",
      selectRoom: "Select a room",
      yourStay: "Your Stay",
      nights: "nights",
      night: "night",
      perNight: "per night",
      totalPrice: "Total Price",
      roomPrice: "Room Price",
      upsellsPrice: "Experiences",
      proceedToPayment: "Proceed to Payment",
      continueToDetails: "Continue to Details",
      guestDetails: "Guest Details",
      fullName: "Full Name",
      email: "Email Address",
      phone: "Phone Number",
      specialRequests: "Special Requests",
      optional: "Optional",
      enhanceStay: "Enhance Your Stay",
      selected: "Selected",
      add: "Add",
      bookingConfirmed: "Booking Confirmed",
      thankYou: "Thank you for choosing Le Château d'Azur",
      confirmationSent: "A confirmation email has been sent to",
      bookingReference: "Booking Reference",
      viewBooking: "View Booking Details",
      returnHome: "Return to Home"
    },
    // Rooms
    rooms: {
      title: "Rooms & Suites",
      subtitle: "Discover our collection of exquisite accommodations",
      from: "From",
      viewDetails: "View Details",
      sqm: "sqm",
      maxGuests: "Max Guests",
      amenities: "Amenities",
      bookThisRoom: "Book This Room",
      roomFeatures: "Room Features",
      bedType: "Bed Type",
      view: "View",
      size: "Size"
    },
    // Experiences/Upsells
    experiences: {
      title: "Curated Experiences",
      subtitle: "Elevate your stay with our bespoke services",
      spa: "Spa & Wellness",
      shuttle: "Private Transfers",
      excursion: "Excursions",
      duration: "Duration",
      addToStay: "Add to Stay",
      added: "Added"
    },
    // Chatbot
    chat: {
      title: "Concierge",
      subtitle: "How may I assist you?",
      placeholder: "Type your message...",
      welcome: "Welcome to Le Château d'Azur. I'm your personal concierge. How may I assist you today?",
      thinking: "Thinking..."
    },
    // Footer
    footer: {
      address: "Côte d'Azur, South of France",
      followUs: "Follow Us",
      quickLinks: "Quick Links",
      legal: "Legal",
      privacy: "Privacy Policy",
      terms: "Terms & Conditions",
      copyright: "© 2024 Le Château d'Azur. All rights reserved."
    },
    // Common
    common: {
      loading: "Loading...",
      error: "An error occurred",
      retry: "Retry",
      close: "Close",
      back: "Back",
      next: "Next",
      confirm: "Confirm",
      cancel: "Cancel"
    }
  },
  fr: {
    // Navigation
    nav: {
      home: "Accueil",
      rooms: "Chambres & Suites",
      experiences: "Expériences",
      dining: "Restaurant",
      spa: "Spa",
      gallery: "Galerie",
      contact: "Contact",
      bookNow: "Réserver"
    },
    // Hero
    hero: {
      title: "Le Château d'Azur",
      subtitle: "Un Sanctuaire Méditerranéen",
      tagline: "Où l'élégance française rencontre la côte azuréenne",
      discover: "Découvrir"
    },
    // Booking Widget
    booking: {
      checkIn: "Arrivée",
      checkOut: "Départ",
      guests: "Voyageurs",
      guest: "Voyageur",
      adults: "Adultes",
      children: "Enfants",
      searchAvailability: "Vérifier Disponibilité",
      selectDates: "Sélectionner les dates",
      selectRoom: "Sélectionner une chambre",
      yourStay: "Votre Séjour",
      nights: "nuits",
      night: "nuit",
      perNight: "par nuit",
      totalPrice: "Prix Total",
      roomPrice: "Prix Chambre",
      upsellsPrice: "Expériences",
      proceedToPayment: "Procéder au Paiement",
      continueToDetails: "Continuer",
      guestDetails: "Informations Client",
      fullName: "Nom Complet",
      email: "Adresse Email",
      phone: "Téléphone",
      specialRequests: "Demandes Spéciales",
      optional: "Optionnel",
      enhanceStay: "Enrichissez Votre Séjour",
      selected: "Sélectionné",
      add: "Ajouter",
      bookingConfirmed: "Réservation Confirmée",
      thankYou: "Merci d'avoir choisi Le Château d'Azur",
      confirmationSent: "Un email de confirmation a été envoyé à",
      bookingReference: "Référence de Réservation",
      viewBooking: "Voir les Détails",
      returnHome: "Retour à l'Accueil"
    },
    // Rooms
    rooms: {
      title: "Chambres & Suites",
      subtitle: "Découvrez notre collection d'hébergements d'exception",
      from: "À partir de",
      viewDetails: "Voir Détails",
      sqm: "m²",
      maxGuests: "Capacité Max",
      amenities: "Équipements",
      bookThisRoom: "Réserver Cette Chambre",
      roomFeatures: "Caractéristiques",
      bedType: "Type de Lit",
      view: "Vue",
      size: "Superficie"
    },
    // Experiences/Upsells
    experiences: {
      title: "Expériences Sur Mesure",
      subtitle: "Sublimez votre séjour avec nos services exclusifs",
      spa: "Spa & Bien-être",
      shuttle: "Transferts Privés",
      excursion: "Excursions",
      duration: "Durée",
      addToStay: "Ajouter au Séjour",
      added: "Ajouté"
    },
    // Chatbot
    chat: {
      title: "Conciergerie",
      subtitle: "Comment puis-je vous aider?",
      placeholder: "Écrivez votre message...",
      welcome: "Bienvenue au Château d'Azur. Je suis votre concierge personnel. Comment puis-je vous aider aujourd'hui?",
      thinking: "Réflexion..."
    },
    // Footer
    footer: {
      address: "Côte d'Azur, Sud de la France",
      followUs: "Suivez-nous",
      quickLinks: "Liens Rapides",
      legal: "Mentions Légales",
      privacy: "Politique de Confidentialité",
      terms: "Conditions Générales",
      copyright: "© 2024 Le Château d'Azur. Tous droits réservés."
    },
    // Common
    common: {
      loading: "Chargement...",
      error: "Une erreur est survenue",
      retry: "Réessayer",
      close: "Fermer",
      back: "Retour",
      next: "Suivant",
      confirm: "Confirmer",
      cancel: "Annuler"
    }
  },
  ar: {
    // Navigation
    nav: {
      home: "الرئيسية",
      rooms: "الغرف والأجنحة",
      experiences: "التجارب",
      dining: "المطعم",
      spa: "السبا",
      gallery: "المعرض",
      contact: "اتصل بنا",
      bookNow: "احجز الآن"
    },
    // Hero
    hero: {
      title: "شاتو دازور",
      subtitle: "ملاذ متوسطي",
      tagline: "حيث تلتقي الأناقة الفرنسية بالساحل اللازوردي",
      discover: "اكتشف"
    },
    // Booking Widget
    booking: {
      checkIn: "تسجيل الوصول",
      checkOut: "تسجيل المغادرة",
      guests: "الضيوف",
      guest: "ضيف",
      adults: "البالغين",
      children: "الأطفال",
      searchAvailability: "التحقق من التوفر",
      selectDates: "اختر التواريخ",
      selectRoom: "اختر غرفة",
      yourStay: "إقامتك",
      nights: "ليالي",
      night: "ليلة",
      perNight: "لليلة",
      totalPrice: "السعر الإجمالي",
      roomPrice: "سعر الغرفة",
      upsellsPrice: "التجارب",
      proceedToPayment: "المتابعة للدفع",
      continueToDetails: "متابعة",
      guestDetails: "بيانات الضيف",
      fullName: "الاسم الكامل",
      email: "البريد الإلكتروني",
      phone: "رقم الهاتف",
      specialRequests: "طلبات خاصة",
      optional: "اختياري",
      enhanceStay: "عزز إقامتك",
      selected: "مختار",
      add: "إضافة",
      bookingConfirmed: "تم تأكيد الحجز",
      thankYou: "شكراً لاختيارك شاتو دازور",
      confirmationSent: "تم إرسال بريد التأكيد إلى",
      bookingReference: "رقم الحجز",
      viewBooking: "عرض تفاصيل الحجز",
      returnHome: "العودة للرئيسية"
    },
    // Rooms
    rooms: {
      title: "الغرف والأجنحة",
      subtitle: "اكتشف مجموعتنا من أماكن الإقامة الفاخرة",
      from: "من",
      viewDetails: "عرض التفاصيل",
      sqm: "متر مربع",
      maxGuests: "الحد الأقصى للضيوف",
      amenities: "المرافق",
      bookThisRoom: "احجز هذه الغرفة",
      roomFeatures: "مميزات الغرفة",
      bedType: "نوع السرير",
      view: "الإطلالة",
      size: "المساحة"
    },
    // Experiences/Upsells
    experiences: {
      title: "تجارب مختارة",
      subtitle: "ارتقِ بإقامتك مع خدماتنا المميزة",
      spa: "السبا والعافية",
      shuttle: "النقل الخاص",
      excursion: "الرحلات",
      duration: "المدة",
      addToStay: "أضف للإقامة",
      added: "تمت الإضافة"
    },
    // Chatbot
    chat: {
      title: "الكونسيرج",
      subtitle: "كيف يمكنني مساعدتك؟",
      placeholder: "اكتب رسالتك...",
      welcome: "مرحباً بك في شاتو دازور. أنا الكونسيرج الخاص بك. كيف يمكنني مساعدتك اليوم؟",
      thinking: "جاري التفكير..."
    },
    // Footer
    footer: {
      address: "كوت دازور، جنوب فرنسا",
      followUs: "تابعنا",
      quickLinks: "روابط سريعة",
      legal: "قانوني",
      privacy: "سياسة الخصوصية",
      terms: "الشروط والأحكام",
      copyright: "© 2024 شاتو دازور. جميع الحقوق محفوظة."
    },
    // Common
    common: {
      loading: "جاري التحميل...",
      error: "حدث خطأ",
      retry: "إعادة المحاولة",
      close: "إغلاق",
      back: "رجوع",
      next: "التالي",
      confirm: "تأكيد",
      cancel: "إلغاء"
    }
  }
};

export const getTranslation = (lang, key) => {
  const keys = key.split('.');
  let result = translations[lang] || translations.en;
  for (const k of keys) {
    result = result?.[k];
  }
  return result || key;
};
